<template>
  <div>
    <slot name="button" :showExcell="SHOW"></slot>
    <export-excel
      ref="exportExcel"
      :type="excell"
      :data="data"
      class="u-display-none"
      :fields="fieldsData"
      :name="getExcelFileName(fileName)"
    >
    </export-excel>
    <modal v-model="showExcellFields" :title="$t('common.export')" hide-footer>
      <div>
        <not-found v-if="data.length === 0"></not-found>
        <div v-else-if="step === 1" class="u-text-align-left">
          <p class="u-color-muted">{{ $t("common.exportDescription") }}</p>
          <div class="u-margin-top">
            <Button
              @click="chooseType = 'all'"
              :variant="chooseType === 'all' ? 'success' : 'light-success'"
              size="lg"
            >
              {{ $t("common.exportAll") }}
            </Button>
            <Button
              class="u-margin-left-small"
              @click="chooseType = 'select'"
              :variant="chooseType === 'select' ? 'success' : 'light-success'"
              size="lg"
            >
              {{ $t("common.exportSelected") }}
            </Button>
          </div>
          <div class="o-alert o-alert--primary u-margin-top">
            {{ $t("common.exportDescription2") }}
          </div>
          <div
            class="u-margin-top u-display-flex u-align-items-center u-justify-content-flex-end"
          >
            <Button @click="showExcellFields = false">
              {{ $t("common.close") }}
            </Button>
            <Button
              class="u-margin-left-small"
              variant="success"
              @click="MIDDLEWARE()"
            >
              {{
                chooseType === "all"
                  ? $t("common.download")
                  : $t("common.continue")
              }}
            </Button>
          </div>
        </div>
        <div v-else class="u-text-align-left">
          <p class="u-color-muted">
            {{ $t("common.selectFields") }}
          </p>
          <div class="u-margin-top">
            <ul class="c-list">
              <li
                class="c-list__item"
                @click="field.show = !field.show"
                v-for="(field, i) in fieldsArray"
                :key="i"
              >
                <Checkbox readonly :value="field.show" :label="field.name" />
              </li>
            </ul>
          </div>
          <div
            class="u-margin-top u-display-flex u-align-items-center u-justify-content-flex-end"
          >
            <Button @click="STEP_BACK">
              {{ $t("common.back") }}
            </Button>
            <Button variant="success" @click="generateByFields">
              {{ $t("common.download") }}
            </Button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
function getOS() {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes("mac")) {
    return { platform: "macOS", excell: "csv" };
  } else if (userAgent.includes("win")) {
    return { platform: "Windows", excell: "xls" };
  } else {
    return { platform: "Windows", excell: "xls" };
  }
}
import Modal from "@/components/Base/Modal.vue";
import Button from "./Button.vue";
import Checkbox from "./Inputs/Checkbox.vue";
import NotFound from "./NotFound.vue";
export default {
  components: {
    Modal,
    Checkbox,
    Button,
    NotFound,
  },
  data() {
    return {
      showExcellFields: false,
      excell: getOS().excell,
      chooseType: "all",
      step: 1,
      fieldsData: {},
      fieldsArray: [],
    };
  },
  watch: {
    fields: {
      deep: true,
      handler() {
        this.fieldsData = { ...this.fields };
      },
    },
  },
  props: {
    fileName: String,
    data: Array,
    fields: Object,
  },
  methods: {
    STEP_BACK() {
      this.step = 1;
      setTimeout(() => {
        this.showExcellFields = true;
      }, 250);
    },
    generateByFields() {
      const json = {};
      this.fieldsArray.forEach((field) => {
        if (field.show) {
          json[field.name] = field.key;
        }
      });
      this.fieldsData = json;
      setTimeout(() => {
        this.$refs.exportExcel.generate();
        console.log("buradatım?");
      }, 250);
    },
    MIDDLEWARE() {
      if (this.chooseType === "all") {
        this.generate();
      } else {
        this.step = 2;
        this.SET_EXCEL_FIELDS();
        setTimeout(() => {
          this.showExcellFields = true;
        }, 100);
      }
    },
    SET_EXCEL_FIELDS() {
      this.fieldsArray = Object.keys(this.fields).map((field) => {
        return {
          key: this.fields[field],
          name: field,
          show: true,
        };
      });
    },
    SHOW() {
      // this.step = 1;
      this.showExcellFields = true;
    },
    getExcelFileName(name) {
      return `${name}.${this.excell}`;
    },
    generate() {
      console.log(this.$refs);

      this.$refs.exportExcel.generate();
    },
  },
  mounted() {
    this.fieldsData = { ...this.fields };
  },
};
</script>

<style></style>
